export const INSTALLER_LIST_LIMIT = 1000;
export const INSTALLER_PAGE_SIZE = 20;
export const columns = [
    {
        Header: 'Name',
        accessor: 'Name',
        sortType: 'basic',
    },
    {
        Header: 'Email',
        accessor: 'Email',
        sortType: 'basic',
    },
    {
        Header: 'Phone',
        accessor: 'Phone',
        sortType: 'basic',
    },
    {
        Header: 'Company ID',
        accessor: 'CompanyID',
        sortType: 'basic',
    },
];
